import { useContext, useEffect } from "react";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import TablaCandidatoGestionIngreso from "./TablaCandidatoGestionIngreso";

interface ITablaRegistroGestionIngreso {
  /** "MASIVO" o "PROFESIONAL". */
  tipoProceso: string;
}

const TablaRegistroGestionIngreso = ({ tipoProceso }: ITablaRegistroGestionIngreso) => {
  const { toasts, getListaGeneral, getExclusiones, getToken, token } =
    useContext(SeleccionContext);

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token) {
      getListaGeneral({ token });
      getExclusiones({ token });
    }
  }, [token]);

  return (
    <>
      {toasts}
      <TablaCandidatoGestionIngreso tipoProceso={tipoProceso} />
    </>
  );
};

export default TablaRegistroGestionIngreso;
